module.exports = __webpack_public_path__ + "img/cadeado.09051262.png";